import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { FONT_WEIGHT_MEDIUM, brand, gray_3, gray_5, gray_6 } from '../../../styles/rn/var';
export default CustomStyleSheet({
  tipContainer: {
    paddingTop: 60,
    alignItems: 'center',
    justifyContent: 'center'
  },
  tipSelectContainer: {
    paddingTop: 150,
    alignItems: 'center',
    justifyContent: 'center'
  },
  tipImage: {
    height: 200,
    width: 200
  },
  tipText: {
    fontSize: 14,
    color: gray_3,
    marginTop: -50
  },
  tipSelectText: {
    fontSize: 14,
    color: gray_3,
    paddingTop: 16
  },
  loadingContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  noMoreContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16
  },
  noMoreText: {
    fontSize: 14,
    lineHeight: 16,
    color: gray_5
  },
  userTabsContainer: {
    flexDirection: 'row',
    height: 44,
    borderBottomWidth: 0.5,
    borderBottomColor: gray_6,
    backgroundColor: '#fff'
  },
  userTab: {
    flex: 1,
    flexBasis: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    lineHeight: 16
  },
  userTabSelected: _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
    color: brand,
    borderBottomWidth: 2,
    borderBottomColor: brand
  }),
  tabsTitleContainer: {
    backgroundColor: '#fff'
  },
  tabsContent: {
    backgroundColor: '#f5f5f5'
  },
  notFound: {
    shadowOffset: {
      width: 0,
      height: 0
    },
    shadowRadius: 6,
    shadowColor: 'rgba(0, 0, 0, 0.06)',
    shadowOpacity: 1,
    elevation: 1
  },
  notFoundButton: {
    margin: 8
  }
});